import React from "react";
import Modal from "../../../components/ui/modal";
import Button from "../../../components/ui/button";
import { TRescheduleAppointmentDetails, TTableUser } from "../../../types";
import { useCancelAppointment } from "../../../apis/doctor";

interface IProps {
  isOpen: boolean;
  onClose: React.Dispatch<React.SetStateAction<boolean>>;
  openRescheduleModal: React.Dispatch<React.SetStateAction<boolean>>;
  title: string;
  appointment: TRescheduleAppointmentDetails
}

const CancelAppointmentModal = ({
  isOpen,
  onClose,
  openRescheduleModal,
  title,
  appointment
}: IProps) => {
  const handleClick = (
    openFn: React.Dispatch<React.SetStateAction<boolean>>
  ) => {
    openFn(true);
  };
  const { mutate: cancelAppointment, isPending } = useCancelAppointment();
  return (
    <Modal
      isOpen={isOpen}
      onClose={() => onClose(false)}
      title={title}
      className="w-[35%] min-w-[400px] max-w-[500px] p-[40px]"
    >
      <div className="mt-[30px] flex flex-col gap-[30px]">
        <div>
          {`Are you sure you want to cancel this appointment with ${appointment["Patient Name"]}?`}
        </div>
        <div className="flex items-center justify-between">
          <Button
            theme="tertiary"
            text="No, Reschedule"
            className="rounded-md"
            size="md"
            onClick={() => {
              handleClick(openRescheduleModal);
              onClose(false);
            }}
          />
          <Button
            theme="danger"
            text="Yes, Cancel"
            className="rounded-md"
            size="md"
            loading={isPending}
            onClick={() => {
              cancelAppointment(
                { appointmentId: appointment["Appointment ID"] },
                {
                  onSuccess: () => {
                    onClose(false);
                  },
                }
              );
            }}
          />
        </div>
      </div>
    </Modal>
  );
};

export default CancelAppointmentModal;
